/**
 * Created by nghinv on Sun Jun 13 2021
 * Copyright (c) 2021 nghinv@lumi.biz
 */

export const TabbarHeight = 44;
